export default __webpack_public_path__ + "static/media/interpreting_2.6e03c619.jpg";